var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row pt-3 l-m-b-20" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col-3 text-right" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  _vm.showModal = true
                }
              }
            },
            [_vm._v("\n        ADD TEMPLATE\n      ")]
          )
        ])
      ]),
      _vm._v(" "),
      !_vm.templates
        ? [
            _c(
              "vue-content-loading",
              { attrs: { width: 800, height: 450 } },
              _vm._l(15, function(x) {
                return _c("rect", {
                  key: x,
                  attrs: {
                    x: "10",
                    y: 15 * x * 1.4,
                    rx: "5",
                    ry: "5",
                    width: "720",
                    height: "6"
                  }
                })
              })
            )
          ]
        : [
            _c("table", { staticClass: "table m-table table-hover l-m-t-20" }, [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  _vm._l(_vm.templates, function(template) {
                    return _c(
                      "tr",
                      {
                        key: template.id,
                        staticClass: "pointer",
                        on: {
                          click: function($event) {
                            _vm.editTemplate(template.id)
                          }
                        }
                      },
                      [
                        _c("td", [_vm._v(_vm._s(template.id))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(template.name))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(template.subject))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(template.body))])
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.templates && !_vm.templates.length
                    ? _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass: "text-center",
                            attrs: { colspan: "4" }
                          },
                          [_vm._v("\n            No results found\n          ")]
                        )
                      ])
                    : _vm._e()
                ],
                2
              )
            ])
          ],
      _vm._v(" "),
      _vm.showModal
        ? _c(
            "modal",
            { attrs: { size: "modal-large" }, on: { close: _vm.closeModal } },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("h4", [_vm._v("Follow up template")])
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                _c("div", { staticClass: "row mb-2" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c("div", { staticClass: "select-wrap" }, [
                        _c("label", [_vm._v("Template name")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.template.name,
                              expression: "template.name"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text" },
                          domProps: { value: _vm.template.name },
                          on: {
                            keydown: function($event) {
                              _vm.clearError($event)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.template,
                                "name",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("error-field", {
                        attrs: { errors: _vm.errors, field: "name" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c("div", { staticClass: "select-wrap" }, [
                        _c("label", [_vm._v("Email subject")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.template.subject,
                              expression: "template.subject"
                            }
                          ],
                          ref: "subject",
                          staticClass: "form-control",
                          domProps: { value: _vm.template.subject },
                          on: {
                            keydown: function($event) {
                              _vm.clearError($event)
                            },
                            click: function($event) {
                              _vm.addingVariableOn = "subject"
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.template,
                                "subject",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("error-field", {
                        attrs: { errors: _vm.errors, field: "subject" }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mb-2" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c("div", { staticClass: "select-wrap h-auto" }, [
                        _c("label", [_vm._v("Email body")]),
                        _vm._v(" "),
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.template.body,
                              expression: "template.body"
                            }
                          ],
                          ref: "ta",
                          staticClass: "select-wrap-textarea form-control",
                          attrs: { cols: "30", rows: "10" },
                          domProps: { value: _vm.template.body },
                          on: {
                            click: function($event) {
                              _vm.addingVariableOn = "ta"
                            },
                            keydown: function($event) {
                              _vm.clearError($event)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.template,
                                "body",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("error-field", {
                        attrs: { errors: _vm.errors, field: "body" }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mb-4" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    _vm._l(_vm.variables, function(variable, key, index) {
                      return _c(
                        "span",
                        {
                          key: index,
                          staticClass:
                            "badge badge-primary mx-1 unselectable pointer",
                          on: {
                            dblclick: function($event) {
                              _vm.insertVariable(variable)
                            }
                          }
                        },
                        [_vm._v(_vm._s(key))]
                      )
                    })
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12 text-right" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-delete float-left",
                        attrs: { type: "button", disabled: !_vm.template.id },
                        on: { click: _vm.deleteFollowup }
                      },
                      [_vm._v("\n            Delete\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary",
                        attrs: { type: "button" },
                        on: { click: _vm.closeModal }
                      },
                      [_vm._v("\n            Cancel\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary ld-ext-right",
                        class: _vm.loadingButton ? "running" : "",
                        attrs: { type: "button", disabled: _vm.buttonDisabled },
                        on: { click: _vm.save }
                      },
                      [
                        _vm._v("\n            Save\n            "),
                        _c("div", { staticClass: "ld ld-ball ld-flip" })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" })
              ])
            ]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-9" }, [
      _c("h1", [_vm._v("Follow up templates")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "m-table__heading" }, [
      _c("tr", [
        _c("th", { staticClass: "m-table__id" }, [_vm._v("ID")]),
        _vm._v(" "),
        _c("th", [_vm._v("Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Subject")]),
        _vm._v(" "),
        _c("th", [_vm._v("Body")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-429aa88d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-429aa88d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/Mailing/FollowUpTemplates.vue
// module id = null
// module chunks = 